import {Injectable, SimpleChanges} from '@angular/core';
import {TyresCommoditiesService} from './tyres-commodities.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {BehaviorSubject} from 'rxjs';
import {MovementsDetailModel} from '../../tyres/models/movements-detail.model';

@Injectable()
export class TyresMovementStatusService {

    private operator = '';
    private movement: MovementsDetailModel;
    private statusMap: Map<string, string> = new Map<string, string>();

    private currentStatusKey: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    currentStatusKey$ = this.currentStatusKey.asObservable();

    constructor(public tyreCommodities: TyresCommoditiesService) {
        this.generateMap();
    }

    get is_ready() {
        return !Utilities.isVoid(this.movement);
    }

    setMovement(movement: MovementsDetailModel) {
        if (Utilities.isVoid(movement)) {
            this.currentStatusKey.next('');
            return;
        }
        this.movement = movement;
        this.checkOperator();
        this.calculateStatus();
    }

    private checkOperator() {
        if (this.tyreCommodities.isCenterA(this.movement)) {
            this.operator = 'A';
        } else if (this.tyreCommodities.isCenterB(this.movement)) {
            this.operator = 'B';
        } else if (this.tyreCommodities.isAld()) {
            this.operator = 'ALD';
        } else if (this.tyreCommodities.isCustomerService()) {
            this.operator = 'CS';
        } else if (this.tyreCommodities.isPoolFleet()) {
            this.operator = 'FLEET_POOL';
        }
    }

    private calculateStatus() {
        if (Utilities.isVoid(this.operator)) return;
        if (this.operator == 'A') {
            this.calculateForCenterA();
        } else if (this.operator == 'B') {
            this.calculateForCenterB();
        } else if (this.operator == 'CS' || this.operator == 'ALD') {
            this.calculateForAldAndCustomerService();
        } else if (this.operator == 'FLEET_POOL') {
            this.calculateForFleetPool();
        }
    }

    private calculateForCenterA() {
        if (this.requestNotInChargeFromAandB()) { //11
            this.currentStatusKey.next('NEW');
        } else if (this.requestRejectCenterANotManagedB()) { //12
            this.currentStatusKey.next('REJECT');
        } else if (this.requestRejectCenterBNotManagedA()) { //13
            this.currentStatusKey.next('AWAITING_WITHDRAWAL_PLUS');
        } else if (this.requestTakedInChargeANoTManagedB()) { //14
            this.currentStatusKey.next('AWAITING_WITHDRAWAL');
        } else if (this.requestTakedInChargeBNoTManagedA()) { //15
            this.currentStatusKey.next('NEW');
        } else if (this.requestTakedInChargeARejectedB()) { //16
            this.currentStatusKey.next('AWAITING_WITHDRAWAL_PLUS');
        } else if (this.requestRejectFromATakedInChargeB()) { //17
            this.currentStatusKey.next('REJECT');
        } else if (this.requestTakedInChargeAandB()) { //18
            this.currentStatusKey.next('AWAITING_WITHDRAWAL');
        } else if (this.movement.cod_transfer_status == 'WITHDRAWN') {
            this.currentStatusKey.next('CLOSED');
        } else if (this.movement.cod_transfer_status == 'COMPLETED') {
            this.currentStatusKey.next('CLOSED');
        } else if (this.movement.cod_transfer_status == 'INCOMPLETE') {
            this.currentStatusKey.next('CLOSED');
        } else if (this.movement.cod_transfer_status == 'RESOLVED') {
            this.currentStatusKey.next('CLOSED');
        } else if (this.movement.cod_transfer_status == 'CANCELED') {
            this.currentStatusKey.next('ANNULLED');
        } else {
            this.currentStatusKey.next(this.movement.cod_transfer_status);
        }
    }

    private calculateForCenterB() {
        if (this.requestNotInChargeFromAandB()) { //11
            this.currentStatusKey.next('NEW');
        } else if (this.requestRejectCenterANotManagedB()) { //12
            this.currentStatusKey.next('ANNULLED');
        } else if (this.requestRejectCenterBNotManagedA()) { //13
            this.currentStatusKey.next('REJECT');
        } else if (this.requestTakedInChargeANoTManagedB()) { //14
            this.currentStatusKey.next('NEW');
        } else if (this.requestTakedInChargeBNoTManagedA()) { //15
            this.currentStatusKey.next('ON_HOLD');
        } else if (this.requestTakedInChargeARejectedB()) { //16
            this.currentStatusKey.next('REJECT');
        } else if (this.requestRejectFromATakedInChargeB()) { //17
            this.currentStatusKey.next('ANNULLED');
        } else if (this.requestTakedInChargeAandB()) { //18
            this.currentStatusKey.next('ON_HOLD');
        } else if (this.movement.cod_transfer_status == 'COMPLETED') {
            this.currentStatusKey.next('CLOSED');
        } else if (this.movement.cod_transfer_status == 'INCOMPLETE') {
            this.currentStatusKey.next('REPORTED');
        } else if (this.movement.cod_transfer_status == 'RESOLVED') {
            this.currentStatusKey.next('INCOMPLETE_TO_CLOSED');
        } else if (this.movement.cod_transfer_status == 'CLOSED' /*&&
            Utilities.isVoid(this.movement.date_incomplete) && !Utilities.isVoid(this.movement.date_closed)*/) {
            this.currentStatusKey.next('CLOSED');
        } else if (this.movement.cod_transfer_status == 'CLOSED') {
            this.currentStatusKey.next('INCOMPLETE_CLOSED');
        } else if (this.movement.cod_transfer_status == 'CANCELED') {
            this.currentStatusKey.next('ANNULLED');
        } else {
            this.currentStatusKey.next(this.movement.cod_transfer_status);
        }
    }

    private calculateForAldAndCustomerService() {
        if (this.requestNotInChargeFromAandB()) { //11
            this.currentStatusKey.next('REQUEST');
        } else if (this.requestRejectCenterANotManagedB()) { //12
            this.currentStatusKey.next('MANAGE');
        } else if (this.requestRejectCenterBNotManagedA()) { //13
            this.currentStatusKey.next('MANAGE');
        } else if (this.requestTakedInChargeANoTManagedB()) { //14
            this.currentStatusKey.next('REQUEST');
        } else if (this.requestTakedInChargeBNoTManagedA()) { //15
            this.currentStatusKey.next('REQUEST');
        } else if (this.requestTakedInChargeARejectedB()) { //16
            this.currentStatusKey.next('MANAGE');
        } else if (this.requestRejectFromATakedInChargeB()) { //17
            this.currentStatusKey.next('MANAGE');
        } else if (this.requestTakedInChargeAandB()) { //18
            this.currentStatusKey.next('IN_CHARGE');
        } else if (this.movement.cod_transfer_status == 'COMPLETED') {
            this.currentStatusKey.next('CLOSED');
        } else if (this.movement.cod_transfer_status == 'INCOMPLETE') {
            this.currentStatusKey.next('REPORTED');
        } else if (this.movement.cod_transfer_status == 'RESOLVED') {
            this.currentStatusKey.next('INCOMPLETE_TO_CLOSED');
        } else if (this.movement.cod_transfer_status == 'CLOSED') {
            this.currentStatusKey.next('INCOMPLETE_CLOSED');
        } else if (this.movement.cod_transfer_status == 'CANCELED') {
            this.currentStatusKey.next('ANNULLED');
        } else {
            this.currentStatusKey.next(this.movement.cod_transfer_status);
        }
    }

    private calculateForFleetPool() {
        if (this.requestNotInChargeFromAandB()) { //11
            this.currentStatusKey.next('REQUEST');
        } else if (this.requestRejectCenterANotManagedB()) { //12
            this.currentStatusKey.next('MANAGE');
        } else if (this.requestRejectCenterBNotManagedA()) { //13
            this.currentStatusKey.next('MANAGE');
        } else if (this.requestTakedInChargeANoTManagedB()) { //14
            this.currentStatusKey.next('REQUEST');
        } else if (this.requestTakedInChargeBNoTManagedA()) { //15
            this.currentStatusKey.next('REQUEST');
        } else if (this.requestTakedInChargeARejectedB()) { //16
            this.currentStatusKey.next('MANAGE');
        } else if (this.requestRejectFromATakedInChargeB()) { //17
            this.currentStatusKey.next('MANAGE');
        } else if (this.requestTakedInChargeAandB()) { //18
            this.currentStatusKey.next('IN_CHARGE');
        } else if (this.movement.cod_transfer_status == 'COMPLETED') {
            this.currentStatusKey.next('CLOSED');
        } else if (this.movement.cod_transfer_status == 'INCOMPLETE') {
            this.currentStatusKey.next('REPORTED');
        } else if (this.movement.cod_transfer_status == 'RESOLVED') {
            this.currentStatusKey.next('INCOMPLETE_TO_CLOSED');
        } else if (this.movement.cod_transfer_status == 'CLOSED') {
            this.currentStatusKey.next('INCOMPLETE_CLOSED');
        } else if (this.movement.cod_transfer_status == 'CANCELED') {
            this.currentStatusKey.next('ANNULLED');
        } else {
            this.currentStatusKey.next(this.movement.cod_transfer_status);
        }
    }

    private requestNotInChargeFromAandB(): boolean {
        if (!this.is_ready) return false;
        return this.movement.cod_transfer_status == 'NEW' &&
            Utilities.isVoid(this.movement.date_expected_withdrawal_availability) &&
            Utilities.isVoid(this.movement.flag_source_outcome) &&
            Utilities.isVoid(this.movement.date_source_outcome) &&
            Utilities.isVoid(this.movement.source_outcome_reason) &&
            Utilities.isVoid(this.movement.flag_destination_outcome) &&
            Utilities.isVoid(this.movement.date_destination_outcome) &&
            Utilities.isVoid(this.movement.destination_outcome_reason) &&
            Utilities.isVoid(this.movement.flag_ok) &&
            Utilities.isVoid(this.movement.date_ok);
    }

    private requestRejectCenterANotManagedB() {
        if (!this.is_ready) return false;
        return this.movement.cod_transfer_status == 'NEW' &&
            Utilities.isVoid(this.movement.date_expected_withdrawal_availability) &&
            !Utilities.isVoid(this.movement.flag_source_outcome) &&
            this.movement.flag_source_outcome == false &&
            !Utilities.isVoid(this.movement.date_source_outcome) &&
            !Utilities.isVoid(this.movement.source_outcome_reason) &&

			((['SALE', 'CARSALES', 'CUSTOMER_RELEASE'].indexOf(this.movement.cod_transfer_type) > -1) ||
			(Utilities.isVoid(this.movement.flag_destination_outcome) &&
            Utilities.isVoid(this.movement.date_destination_outcome) &&
            Utilities.isVoid(this.movement.destination_outcome_reason))) &&
            !Utilities.isVoid(this.movement.flag_ok) &&
            this.movement.flag_ok == false &&
            Utilities.isVoid(this.movement.date_ok);
    }

    private requestRejectCenterBNotManagedA() {
        if (!this.is_ready) return false;
        return this.movement.cod_transfer_status == 'NEW' &&
            Utilities.isVoid(this.movement.date_expected_withdrawal_availability) &&
            Utilities.isVoid(this.movement.flag_source_outcome) &&
            Utilities.isVoid(this.movement.date_source_outcome) &&
            Utilities.isVoid(this.movement.source_outcome_reason) &&
            !Utilities.isVoid(this.movement.flag_destination_outcome) &&
            this.movement.flag_destination_outcome == false &&
            !Utilities.isVoid(this.movement.date_destination_outcome) &&
            !Utilities.isVoid(this.movement.destination_outcome_reason) &&
            !Utilities.isVoid(this.movement.flag_ok) &&
            this.movement.flag_ok == false &&
            Utilities.isVoid(this.movement.date_ok);
    }

    private requestTakedInChargeANoTManagedB() {
        if (!this.is_ready) return false;
        return this.movement.cod_transfer_status == 'IN_CHARGE' &&
            !Utilities.isVoid(this.movement.date_expected_withdrawal_availability) &&
            !Utilities.isVoid(this.movement.flag_source_outcome) &&
            this.movement.flag_source_outcome == true &&
            !Utilities.isVoid(this.movement.date_source_outcome) &&
            Utilities.isVoid(this.movement.source_outcome_reason) &&
            Utilities.isVoid(this.movement.flag_destination_outcome) &&
            Utilities.isVoid(this.movement.date_destination_outcome) &&
            Utilities.isVoid(this.movement.destination_outcome_reason) &&
            Utilities.isVoid(this.movement.flag_ok) &&
            Utilities.isVoid(this.movement.date_ok);
    }

    //rows 15
    private requestTakedInChargeBNoTManagedA() {
        if (!this.is_ready) return false;
        return ['NEW', 'IN_CHARGE'].indexOf(this.movement.cod_transfer_status) > -1 &&
            Utilities.isVoid(this.movement.date_expected_withdrawal_availability) &&
            Utilities.isVoid(this.movement.flag_source_outcome) &&
            Utilities.isVoid(this.movement.date_source_outcome) &&
            Utilities.isVoid(this.movement.source_outcome_reason) &&
            !Utilities.isVoid(this.movement.flag_destination_outcome) &&
            this.movement.flag_destination_outcome == true &&
            !Utilities.isVoid(this.movement.date_destination_outcome) &&
            Utilities.isVoid(this.movement.destination_outcome_reason) &&
            Utilities.isVoid(this.movement.flag_ok) &&
            Utilities.isVoid(this.movement.date_ok);
    }

    //rows 16
    private requestTakedInChargeARejectedB() {
        if (!this.is_ready) return false;
        return this.movement.cod_transfer_status == 'IN_CHARGE' &&
            !Utilities.isVoid(this.movement.date_expected_withdrawal_availability) &&
            !Utilities.isVoid(this.movement.flag_source_outcome) &&
            this.movement.flag_source_outcome == true &&
            !Utilities.isVoid(this.movement.date_source_outcome) &&
            Utilities.isVoid(this.movement.source_outcome_reason) &&
            !Utilities.isVoid(this.movement.flag_destination_outcome) &&
            this.movement.flag_destination_outcome == false &&
            !Utilities.isVoid(this.movement.date_destination_outcome) &&
            !Utilities.isVoid(this.movement.destination_outcome_reason) &&
            !Utilities.isVoid(this.movement.flag_ok) &&
            this.movement.flag_ok == false &&
            Utilities.isVoid(this.movement.date_ok);
    }

    // rows17
    private requestRejectFromATakedInChargeB() {
        if (!this.is_ready) return false;
        return ['NEW', 'IN_CHARGE'].indexOf(this.movement.cod_transfer_status) > -1 &&
            Utilities.isVoid(this.movement.date_expected_withdrawal_availability) &&
            !Utilities.isVoid(this.movement.flag_source_outcome) &&
            this.movement.flag_source_outcome == false &&
            !Utilities.isVoid(this.movement.date_source_outcome) &&
            !Utilities.isVoid(this.movement.source_outcome_reason) &&
            !Utilities.isVoid(this.movement.flag_destination_outcome) &&
            this.movement.flag_destination_outcome == true &&
            !Utilities.isVoid(this.movement.date_destination_outcome) &&
            Utilities.isVoid(this.movement.destination_outcome_reason) &&
            Utilities.isVoid(this.movement.flag_ok) &&
            Utilities.isVoid(this.movement.date_ok);
    }

    private requestTakedInChargeAandB() {
        if (!this.is_ready) return false;
        return this.movement.cod_transfer_status == 'IN_CHARGE' &&
            !Utilities.isVoid(this.movement.date_expected_withdrawal_availability) &&
            !Utilities.isVoid(this.movement.flag_source_outcome) &&
            this.movement.flag_source_outcome == true &&
            !Utilities.isVoid(this.movement.date_source_outcome) &&
            Utilities.isVoid(this.movement.source_outcome_reason) &&
            !Utilities.isVoid(this.movement.flag_destination_outcome) &&
            this.movement.flag_destination_outcome == true &&
            !Utilities.isVoid(this.movement.date_destination_outcome) &&
            Utilities.isVoid(this.movement.destination_outcome_reason) &&
            !Utilities.isVoid(this.movement.flag_ok) &&
            this.movement.flag_ok == true &&
            !Utilities.isVoid(this.movement.date_ok);
    }

    private generateMap() {
        this.statusMap.set('NEW', 'da lavorare');
        this.statusMap.set('CLOSED', 'chiuso');
        this.statusMap.set('IN_CHARGE', 'presa in carico');
        this.statusMap.set('RESOLVED', 'risolto');
        this.statusMap.set('WITHDRAWN', 'in trasferimento');
        this.statusMap.set('COMPLETED', 'completato');
        this.statusMap.set('CANCELED', 'cancellato');
        this.statusMap.set('INCOMPLETE', 'incompleto');
        this.statusMap.set('ON_HOLD', 'in attesa');
        this.statusMap.set('REPORTED', 'segnalato');
        this.statusMap.set('REQUEST', 'richiesta');
        this.statusMap.set('REJECT', 'rifiutata');
        this.statusMap.set('MANAGE', 'da gestire');
        this.statusMap.set('ANNULLED', 'annullato');
        this.statusMap.set('INCOMPLETE_CLOSED', 'incompleto chiuso');
        this.statusMap.set('INCOMPLETE_TO_CLOSED', 'incompleto da chiudere');
        this.statusMap.set('AWAITING_WITHDRAWAL', 'in attesa di prelievo');
        this.statusMap.set('AWAITING_WITHDRAWAL_PLUS', 'in attesa di prelievo');
    }

    private isSource(): boolean {
        return this.tyreCommodities.isSource(this.movement);
    }

    getStatusName(): string {
        let value = this.currentStatusKey.getValue();
        if (value == null) return '';
        return this.statusMap.get(value);
    }

}
